import { default as React } from 'react';
import { Button } from '../Components/Button';
import { AddIcon, ArrowDropDownIcon } from '../Components/Icons';
import { useAnyPermission } from '../Hooks/usePermissions';
import NoMedications from '../Images/noMedications.svg';
import { MedicationsPermissions } from '../MedicationsPermissions';
import { white } from '../Styles/Colours';
import styles from './MedicationPlaceholder.module.css';
export var MedicationPlaceholder = function (localProps) {
    var userHasPermission = useAnyPermission([
        MedicationsPermissions.PrescribeMedicationsEnrmcScript,
        MedicationsPermissions.PrescribeMedicationsMedicationHistory,
        MedicationsPermissions.PrescribeMedicationsMedicationOrder,
        MedicationsPermissions.PrescribeMedicationsTakeHomeScript,
        MedicationsPermissions.PrescribeComplementaryTherapyOrder
    ]);
    var addButton = userHasPermission && (React.createElement(Button, { onClick: localProps.onClick, startIcon: React.createElement(AddIcon, { color: white }), endIcon: React.createElement(ArrowDropDownIcon, { noPadding: true, size: '20', color: white }), testId: 'newMedication' }, "Add new medication"));
    return (React.createElement("div", { className: styles.placeholder },
        React.createElement("div", { className: styles.placeholderContent },
            React.createElement("img", { src: NoMedications, alt: '' }),
            React.createElement("div", { className: styles.placeholderText }, userHasPermission ? "Add new medication to your patient's record." : 'No medications to display.'),
            addButton)));
};
